import { type RouteRecordRaw } from 'vue-router'

export const LoginRouter: RouteRecordRaw[] = [
  {
    path: '/login',
    component: async () => import('./Login.vue'),
  },
]
